/* Brand Fit Page: model finder, model table filters, product filters. Works on every brand page. */
(function () {
  document.querySelectorAll('[data-bf]').forEach(function (root) {
    var cfgEl = root.querySelector('[data-bf-json]');
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    var brand = cfg.brand;
    var sizeUrl = function (w) { return cfg.sizeUrls[String(w)] || ''; };
    var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var norm = function (s) { return String(s).toLowerCase().replace(/[^a-z0-9]/g, ''); };
    var smooth = function () { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; };

    /* ---------- data: table rows + finder-only models ---------- */
    var rows = [].slice.call(root.querySelectorAll('[data-bf-rows] tr'));
    var data = rows.map(function (r) {
      return { m: r.cells[0].textContent.trim(), c: r.dataset.c, mv: r.dataset.mv, w: +r.dataset.w, straight: r.dataset.s === '1' };
    });
    (cfg.finderOnly || []).forEach(function (f) {
      data.push({ m: f[0], c: brand, mv: cfg.mvs[f[2]], w: f[1], straight: f[3] === 1, finderOnly: true });
    });

    /* ---------- products ---------- */
    var topH = root.querySelector('[data-bf-top-h]'), topAlls = [].slice.call(root.querySelectorAll('[data-bf-top-all]'));
    var showMore = root.querySelector('[data-bf-showmore]'), LIMIT = 8, expanded = false;
    var cards = [].slice.call(root.querySelectorAll('[data-bf-more] .bf-card'));
    var pnote = root.querySelector('[data-bf-pnote]'), matWrap = root.querySelector('[data-bf-mats]');
    var mat = '', pw = '', lastModel = '', lastWatch = '';
    if (matWrap) {
      var seen = {};
      cards.forEach(function (c) { if (c.dataset.matLabel) seen[c.dataset.mat] = seen[c.dataset.mat] || { label: c.dataset.matLabel, n: 0 }; if (seen[c.dataset.mat]) seen[c.dataset.mat].n++; });
      Object.keys(seen).forEach(function (k) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'bf-wbtn'; b.dataset.bfMat = k; b.setAttribute('aria-pressed', 'false');
        b.textContent = seen[k].label + ' ' + seen[k].n;
        matWrap.appendChild(b);
      });
      var mbtns = [].slice.call(matWrap.querySelectorAll('.bf-wbtn'));
      mbtns.forEach(function (b) {
        b.addEventListener('click', function () {
          mat = b.dataset.bfMat;
          mbtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          showProds();
        });
      });
    }
    if (showMore) showMore.addEventListener('click', function () { expanded = true; showProds(); });
    function showProds() {
      var n = 0;
      cards.forEach(function (li) {
        var ok = (!mat || li.dataset.mat === mat) && (!pw || (' ' + li.dataset.w + ' ').indexOf(' ' + pw + ' ') > -1);
        if (ok) n++;
        li.hidden = !ok || (!expanded && n > LIMIT);
        var link = li.querySelector('a[data-href]');
        if (link) {
          var vid = '';
          if (pw) (li.dataset.v || '').split(' ').forEach(function (p) { var kv = p.split(':'); if (kv[0] === pw) vid = kv[1]; });
          link.href = link.dataset.href + (vid ? '?variant=' + vid : '');
        }
      });
      if (showMore) {
        showMore.hidden = expanded || n <= LIMIT;
        showMore.textContent = 'Show all ' + n + ' best sellers';
      }
      if (pnote) {
        pnote.innerHTML = pw ? n + (n === 1 ? ' band comes' : ' bands come') + ' in ' + pw + 'mm, the size for ' + esc(lastModel) + '. <button type="button" class="bf-link" data-bf-pclear>Show all sizes</button>' : '';
        var pc = pnote.querySelector('[data-bf-pclear]');
        if (pc) pc.addEventListener('click', function () { setWidth(''); });
      }
    }
    function setWidth(w) {
      pw = w ? String(w) : '';
      showProds();
      if (topH) topH.textContent = w ? 'Top sellers in ' + w + 'mm for your ' + (lastWatch || brand) + ' Watch' : 'Top sellers for ' + brand + ' watches';
      topAlls.forEach(function (a) {
        var big = a.classList.contains('bf-help-btn');
        a.textContent = w && sizeUrl(w) ? (big ? 'Shop all ' + w + 'mm bands' : 'See all ' + w + 'mm bands') : (big ? 'Shop all bands that fit ' + brand : 'See all bands');
        a.href = w && sizeUrl(w) ? sizeUrl(w) : cfg.allUrl;
      });
    }

    /* ---------- finder ---------- */
    var fq = root.querySelector('[data-bf-q]'), fr = root.querySelector('[data-bf-result]');
    function render() {
      var raw = fq.value.trim(), q = norm(raw);
      setWidth('');
      fr.hidden = !q;
      if (!q) { fr.innerHTML = ''; return; }
      var exact = data.filter(function (d) { return norm(d.m) === q; });
      var partial = exact.length ? [] : data.filter(function (d) { return norm(d.m).indexOf(q) === 0; });
      var hit = exact[0] || (partial.length === 1 ? partial[0] : null);
      if (hit) {
        var named = !hit.finderOnly && cfg.generic.indexOf(hit.c) < 0;
        var label = brand + (named ? ' ' + hit.c : '') + (cfg.feature && hit.mv === cfg.feature ? ' ' + cfg.feature : '');
        var u = sizeUrl(hit.w);
        fr.innerHTML = '<span class="bf-eyebrow">' + esc(hit.m) + ' · ' + esc(label) + '</span>' +
          '<span class="bf-big">Takes a ' + hit.w + 'mm band</span>' +
          '<span>' + (hit.straight ? 'Flat-sided case: choose a straight-end band.' : 'Round case: straight or curved-end bands both fit.') + '</span>' +
          (u ? '<a class="bf-cta" href="' + u + '">Shop all ' + hit.w + 'mm bands</a>' : '');
        lastModel = hit.m;
        lastWatch = brand + (named ? ' ' + hit.c : '') + ' ' + hit.m;
        setWidth(hit.w);
        return;
      }
      if (partial.length > 1) {
        var ws = {}; partial.forEach(function (d) { ws[d.w] = 1; });
        var keys = Object.keys(ws);
        fr.innerHTML = '<span>' + partial.length + ' models start with “' + esc(raw) + '”' + (keys.length === 1 ? ', all ' + keys[0] + 'mm.' : ', in more than one width.') + '</span>' +
          '<span class="bf-small bf-muted">Pick yours: ' + partial.slice(0, 8).map(function (d) { return '<button type="button" data-m="' + esc(d.m) + '">' + esc(d.m) + '</button>'; }).join(', ') + (partial.length > 8 ? ' …' : '') + '</span>';
        return;
      }
      var lr = raw.toLowerCase();
      var isFeat = cfg.feature && norm(cfg.feature).indexOf(norm(raw)) === 0 && q.length >= 3;
      var coll = data.filter(function (d) { return !d.finderOnly && (isFeat ? d.mv === cfg.feature : d.c.toLowerCase().indexOf(lr) > -1); });
      if (coll.length) {
        var names = {}; coll.forEach(function (d) { names[d.c] = 1; });
        var nl = Object.keys(names);
        var what = brand + ' ' + (isFeat ? cfg.feature : (nl.length === 1 ? nl[0] : raw));
        var wl = {}; coll.forEach(function (d) { wl[d.w] = 1; });
        var wk = Object.keys(wl).map(Number).sort(function (a, b) { return a - b; });
        fr.innerHTML = '<span>' + (wk.length === 1
          ? 'Every ' + esc(what) + ' watch we track takes a <strong>' + wk[0] + 'mm</strong> band. Enter your model number to confirm.'
          : esc(what) + ' watches come in ' + wk.length + ' band widths (' + wk[0] + 'mm to ' + wk[wk.length - 1] + 'mm). Check the model number on your case back for an exact match.') + '</span>';
        return;
      }
      fr.innerHTML = '<span>No ' + esc(brand) + ' model matches “' + esc(raw) + '”. Check the number on your case back, or measure your lug width with the size guide below.</span>';
    }
    if (fq) {
      fr.addEventListener('click', function (e) { var b = e.target.closest('button[data-m]'); if (b) { fq.value = b.dataset.m; render(); } });
      fq.addEventListener('input', render);
    }

    /* ---------- model table filters ---------- */
    var tq = root.querySelector('[data-bf-tq]'), tc = root.querySelector('[data-bf-tc]'), tm = root.querySelector('[data-bf-tm]');
    var tcount = root.querySelector('[data-bf-count]'), w = '';
    var wbtns = [].slice.call(root.querySelectorAll('[data-bf-w]'));
    function filter() {
      var q = tq.value.trim().toLowerCase(), c = tc.value, m = tm ? tm.value : '', n = 0;
      rows.forEach(function (r) {
        var ok = (!w || r.dataset.w === w) && (!c || r.dataset.c === c) && (!m || r.dataset.mv === m) && (!q || r.dataset.q.indexOf(q) > -1);
        r.hidden = !ok;
        if (ok) { r.classList.toggle('bf-alt', n % 2 === 1); n++; }
      });
      tcount.textContent = n + (n === 1 ? ' model' : ' models');
    }
    wbtns.forEach(function (b) {
      b.addEventListener('click', function () {
        w = b.dataset.bfW;
        wbtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        filter();
      });
    });
    tq.addEventListener('input', filter); tc.addEventListener('change', filter); if (tm) tm.addEventListener('change', filter);
    var models = root.querySelector('[id^="bf-models-"]');
    root.querySelectorAll('[data-bf-coll]').forEach(function (b) {
      b.addEventListener('click', function () { tc.value = b.dataset.bfColl; tq.value = ''; if (tm) tm.value = ''; filter(); models.scrollIntoView({ behavior: smooth() }); });
    });
    var featBtn = root.querySelector('[data-bf-feature]');
    if (featBtn && tm) featBtn.addEventListener('click', function () { tm.value = featBtn.dataset.bfFeature; tc.value = ''; tq.value = ''; filter(); models.scrollIntoView({ behavior: smooth() }); });

    showProds();
  });
})();
